import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import {
    EMPLOYEE_AUTH_SERVICE_IMPL,
    IEmployeeAuthService,
} from 'pm-src/services/employee-auth/i-employee-auth.service';
import { AUTH_SERVICE_IMPL, IAuthenticationService, UserRole } from 'shared';

@Injectable({
    providedIn: 'root',
})
export class EmployeeAuthGuard  {
    constructor(
        @Inject(EMPLOYEE_AUTH_SERVICE_IMPL)
        private _employeeAuthService: IEmployeeAuthService,
        @Inject(AUTH_SERVICE_IMPL) private _authService: IAuthenticationService,
        private _router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this._authService.currentUser;
        if (!currentUser) {
            this._router.navigate(['/login'], {
                queryParams: { returnUrl: state.url },
            });
            return false;
        }

        if (
            currentUser.hasRoles([UserRole.ProviderShopUser]) &&
            !this._employeeAuthService.hasActiveEmployee()
        ) {
            this._router.navigate(['/employeelogin'], {
                queryParams: { returnUrl: state.url },
            });
            return false;
        }

        return true;
    }
}
